<template>
<!-- Una pagina dedicata alla presentazione dei diversi link ai tutorial -->
  <div>
    <PageTagline :elements="tagline_elem"/>

    <!-- Tutorial contestuale per gli argomenti del form. Vengono passati gli slug name dei video da mostrare -->
    <TutorialContestuale :video_to_show="['area_assistenza']"/>

    <!-- CARD PER CONTENERE LA TABELLA -->
    <b-card no-body class="mr-1 ml-1">
      <b-card-header>
        <h4><font-awesome-icon icon="info-circle" size="lg"/> Tutorial</h4>
      </b-card-header>
      <b-card-body>
        <b-table stacked="md"
                :items="datatable.items"
                :fields="datatable.fields">
          <!-- Creo la prima colonna con il pulsante di Play -->
          <template v-slot:cell(action)="data">
            <!-- Accedendo ad item invece che a value becco i dati di tutta la riga così come tornati
                 dal backend -->
            <b-button class="playbutton"
                      v-b-tooltip.hover.righttop="'visualizza il tutorial'"
                      pill size="sm"
                      variant="primary"
                      @click.prevent="play_video($event, data.item.url, data.item.descrizione )"
                      >Play <b-icon icon="play-fill"></b-icon></b-button>
          </template>
        </b-table>
      </b-card-body>
      <!-- MODALE: Dentro vie è l'elemento b-embed per la visualizzazione del video -->
      <b-modal ref="video_modal" v-model="video_player.show_modal" size="xl" :title="video_player.video_title">
        <b-embed
          type="iframe"
          aspect="4by3"
          :src="video_player.video_url"
          allowfullscreen
        ></b-embed>
        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="primary" size="sm" class="float-right" @click="cancel()">
              Chiudi
            </b-button>
        </template>
      </b-modal>
    </b-card>
  </div>
</template>


<script>
import PageTagline from '@/components/PageTagline'
import TutorialContestuale from '@/components/TutorialContestuale'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'TutorialView',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "TutorialView", link : 'tutorial' } ],

      // Elementi della tabella
      datatable : {
        // Definizione delle colonne da visualizzare
        fields: [
            {
              key: 'action',
              label: '',
              tdClass: 'text-center',
            },
            {
              key: 'descrizione',
              label: 'Contenuto'
            }
        ],
        // Elementi da mostrate nella tabella
        items : []
      },

      // Elementi per la modale e per l'elemento b-embed
      // per la visualizzaizone dei tutorial
      video_player : {
        show_modal : false,
        video_title : null,
        video_url : null
      }

    }
  },
  methods : {
    /**
     * Visualizza il video del tutorial all'interno della modale
     */
    play_video : function ( event, url, descrizione ) {
      this.video_player.video_url = url;
      this.video_player.video_title = descrizione;
      this.video_player.show_modal = true;
    }
  },
  created : function () {
    /**
     * Alla creazione dell'elemento prendiamo i link da mostrare riguardanti i tutorial
     */
    let api_url = apiUrl.staticlinks.list_links.replace( '@ltype', 'tutorial' );
    axios.get( api_url )
    .then( ( response ) => {
      for ( let elem of response.data ){
        this.datatable.items = this.datatable.items.concat( elem.link );
      }
    })
    .catch( ( error ) => {
      generalLib.backend_error_message_box( this, error.response.data );
    });
  },
  components : {
    PageTagline,
    TutorialContestuale
  }
}
</script>


<style scoped>
.playbutton {
  cursor : pointer;
}
</style>